import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Data passed into the RestoreDraftDialogComponent. */
export interface RestoreDraftDialogData {
  /**
   * Name of the first (or only) spec being returned to Revise.
   * Always shown in the dialog title.
   */
  specificationCode: string;
  /**
   * Total number of affected specs. 1 for a single-row prompt;
   * greater than 1 when the bulk-action dropdown triggered the dialog.
   */
  affectedCount: number;
}

/**
 * The user's choice from the restore-draft prompt.
 * - `'restore'` — reload the previously saved draft modifications.
 * - `'reset'`   — initialize from the last released version instead.
 */
export type RestoreDraftDialogResult = 'restore' | 'reset';

@Component({
  selector: 'app-restore-draft-dialog',
  templateUrl: './restore-draft-dialog.component.html',
  styleUrls: ['./restore-draft-dialog.component.scss'],
  standalone: false,
})
export class RestoreDraftDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RestoreDraftDialogComponent, RestoreDraftDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: RestoreDraftDialogData,
  ) {}

  restore(): void {
    this.dialogRef.close('restore');
  }

  reset(): void {
    this.dialogRef.close('reset');
  }

  cancel(): void {
    // Close without a result value; the caller interprets `undefined` as a cancellation.
    this.dialogRef.close();
  }
}
